import { Component } from '@angular/core';
import { RepertoryPanelComponent } from './repertory-panel.component';

@Component({
  selector: 'app-repertory',
  standalone: true,
  imports: [RepertoryPanelComponent],
  template: `<app-repertory-panel mode="page" />`,
})
export class RepertoryComponent {}
